/**
 * General utility functions
 */
export const Util =
	{
		/**
		 * Checks if an object is null or empty
		 * @param Object|null p_obj An object
		 * @returns {boolean} Boolean value True if p_obj is null, undefined or empty
		 */
		isEmpty: (p_obj) =>
		{
			return !p_obj || Object.keys(p_obj).length === 0;
		},

		/**
		 * Checks if an object has an attribute and that item is an array with multiple times
		 * @param {Object} p_obj Object
		 * @param {string} p_key Object key
		 * @returns {boolean} True if has array with 1+ items
		 */
		objHasArray: (p_obj, p_key) =>
		{
			return (p_obj && p_obj[p_key] && Array.isArray(p_obj[p_key]) && p_obj[p_key].length > 0);
		},

		/**
		 * Checks if an object has a property
		 * @param p_obj
		 * @param p_key
		 * @returns {boolean}
		 */
		hasProp: (p_obj, p_key) =>
		{
			if (typeof p_obj === "object")
			{
				return Object.hasOwn(p_obj, p_key);
			}
			return false;
		},

		today: (p_separator = '-', p_format = 'YYYY-MM-DD') =>
		{
			const now = new Date();
			let year = now.getFullYear();
			const month = String(now.getMonth() + 1).padStart(2, '0');
			const day = String(now.getDate()).padStart(2, '0');

			const split_format = p_format.split(' ')

			if (split_format[0].indexOf('YYYY') < 0)
			{
				year = year.toString().slice(-2)
			}

			let date = `${year}-${month}-${day}`
			switch (split_format[0])
			{
				case 'YYYY-MM-DD':
				case 'YY-MM-DD':
					date =  `${year}${p_separator}${month}${p_separator}${day}`;
					break;

				case 'MM-DD-YYYY':
				case 'MM-DD-YY':
					date =  `${month}${p_separator}${day}${p_separator}${year}`;
					break;

				case 'DD-MM-YYYY':
				case 'DD-MM-YY':
					date =  `${day}${p_separator}${month}${p_separator}${year}`;
					break;
			}

			if (split_format.length > 1)
			{
				let hour = String(now.getHours()).padStart(2, '0');
				const min = String(now.getMinutes()).padStart(2, '0');
				if (split_format.length === 3)
				{
					if (hour > 12)
					{
						date += ` ${String(hour - 12).padStart(2, '0')}:${min} PM`;
					}
					else
					{
						date += ` ${hour}:${min} AM`;
					}
				}
				else if (split_format.length === 2)
				{
					date += ` ${hour}:${min}`;
				}
			}

			return date;

		},

		formatStringWithKvp(str, kvp) {
			const escapedKeys = Object.keys(kvp).map(key => `\\{${key}\\}`).join("|")
			return str.replace(new RegExp(escapedKeys, "g"), (matched) => {
				return kvp[matched.slice(1, -1)]
			})
		},

		formatString: (toFormat, ...args) => {
			return toFormat.replace(/{(\d+)}/g, (match, index) => {
				return typeof args[index] !== 'undefined' ? args[index] : match
			})
		},

		/**
		 * Adds an action menu item to the array. Sets id to the array length + 1 if no id given
		 * @param p_items {Array<{ "id": number, "text": string}>} Array of action menu items
		 * @param p_name {string} Menu item identifier for event handler (e.g. "delete")
		 * @param p_text {string} Menu item text
		 * @param p_id {number} Menu item id
		 */
		addActionMenuItem: (p_items, p_name, p_text, p_id) =>
		{
			p_items.push({ id: p_id ? p_id : p_items.length + 1, name: p_name, text: p_text });
		},

		/**
		 * Makes a dereferenced deep copy of an object for comparing.
		 * @param p_obj {any}
		 * @returns {any|null}
		 */
		deepCopy(p_item)
		{
			if (p_item)
			{
				return JSON.parse(JSON.stringify(p_item));
			}
			return null;
		}
	}

